export default __webpack_public_path__ + "static/media/copy.6225b210.svg";